import { Component, OnInit, Input, TemplateRef, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import {
  InformacionTablaMaestra,
  EstructuraEspecifica,
  SubForma,
  ValoresEspecificos,
  Option,
  BaseControl,
  ConfirmComponent,
  AccionModal,
} from '@app/shared';
import { CheckListParametersDataService } from './shared/check-list-parameters.data.service';
import { LocalDataSource } from 'ng2-smart-table';
import { Logger, GlobalNotifierService } from '@app/core';
import { CheckListParametersConfig } from './shared/check-list-parameters.config.service';
import { Partial, find, findIndex } from 'lodash';
import { CheckListParametersFormsService } from './shared/check-list-parameters.form.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

const log: Logger = new Logger('CheckListParametersComponent');

@Component({
  selector: 'iw-check-list-parameters',
  templateUrl: './check-list-parameters.component.html',
  styleUrls: ['./check-list-parameters.component.scss'],
  providers: [
    CheckListParametersDataService,
    CheckListParametersFormsService
  ]
})
export class CheckListParametersComponent implements OnInit, OnDestroy {

  // Contiene el formulario de la lista de chequeo
  @Input() form: SubForma;
  // Contiene la maestra seleccionada
  @Input() master: InformacionTablaMaestra;
  // Registros especificos
  @Input() specificRecords: number[];
  // Columna seleccionada
  @Input()
  set columnSelect(c: string) {
    this._columnSelect = c;
    if (c) {
      this.loadOptions();
    } else {
      this.Init();
    }
  }
  // Contiene los valores de la maestra seleccionada
  valuesMaster: Array<ValoresEspecificos> = [];
  // Cadena contenedora de la accion a relaizar en el formulario
  actionForm = '';
  // Accion que se esta realizando
  actionRow = 'Agregar';
  // Contiene la columna seleccionada (el id)
  colSel = '';
  // Mensaje de la ventan de cargando
  messaggeLoading = '';
  // Define cuando esta accion una accion
  loadingProcess = false;
  // Define si la accion a realizar es modificar o actualizar
  modificar = false;
  // Define cuando abre o se cierra el formulario
  openForm = false;
  // Define cuando se edita o se crea en el formulario
  editForm = false;
  // Define cuando renderizar la tabla de los parametros
  reviewTable = false;
  // Configuracion de la tabla
  settings = {};
  // Contiene el registro seleccionado
  rowData = {};
  // Contiene el registro seleccionado de la tabla
  registroSeleccionado: any;
  // Contiene las opciones para seleccionar los registros especificos
  options: Option[] = [];
  // Contiene los controles base de el formulario
  controls: BaseControl<Partial>[] = [];
  // Contiene los registros especificos seleccionados
  specificRecordSelect: any[] = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Columna seleccionada
  private _columnSelect = '';
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia al componente de refactorizacion del formulario de la tabla maestra
  @ViewChild('templateRefactorMasterTable') private templateRefactorMasterTable: TemplateRef<any>;
  // Evento de salida para los registros seleccionados
  @Output() saveRecordSpecific: EventEmitter<Array<number>> = new EventEmitter();

  constructor(
    private clpds: CheckListParametersDataService,
    private clpfs: CheckListParametersFormsService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private gns: GlobalNotifierService,
  ) { }

  async ngOnInit() {
    this.master = await this.clpds.getInformacionMasterTable(this.master.id);
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get columnSelect(): string {
    return this._columnSelect;
  }

  Init() {
    const configTable = new CheckListParametersConfig();
    this.reviewTable = false;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineAction(res.action, res.data);
    });
    if (this.columnSelect) {
      this.colSel = this.columnSelect;
      log.debug(this.colSel);
      this.settings = configTable.generateColumns(this.colSel);
      this.reviewTable = true;
      log.debug('options', this.options);
    }
    this.loadSpecificRecord();
  }

  /**
   * Define las acciones a realizar
   *
   * @param {('add' | 'update' | 'delete' | 'close')} [action='add']
   * @param {*} [data]
   * @memberof CheckListParametersComponent
   */
  defineAction(action: 'add' | 'update' | 'delete' | 'close' = 'add', data?: any) {
    switch (action) {
      case 'update':
        this.actionForm = 'Modificar';
        this.editForm = true;
        this.rowData = data;
        this.controls = this.clpfs.getForm({registros: this.options}, this.rowData);
        this.openForm = true;
        break;
      case 'delete':
        this.confirm.new({
          question: '¿Realmente deseas eliminar el registro?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.rowData = data;
            this.deleteRecordSelect();
          }
        });
        break;
      case 'close':
        this.actionForm = '';
        this.openForm = false;
        this.editForm = false;
        this.rowData = null;
        break;
      default:
        this.actionForm = 'Agregar';
        this.editForm = false;
        this.controls = this.clpfs.getForm({registros: this.options});
        this.openForm = true;
        break;
    }
  }

  /**
   * Carga y refresca los registros de la tabla de registros especificos seleccionados
   *
   * @param {boolean} [reload=false] - Define cuando es cargar o refrescar la informacion
   * @memberof CheckListParametersComponent
   */
  loadSpecificRecord(reload: boolean = false) {
    if (!reload) {
      let records: number[] = [];
      if (
        this.form &&
        this.form.estilo &&
        this.form.estilo['registros_especificos'] &&
        this.form.estilo['registros_especificos'].length
      ) {
        records = this.form.estilo['registros_especificos'];
      } else if (this.specificRecords && this.specificRecords.length) {
        records = this.specificRecords;
      }
      if (records.length) {
        records.forEach((specificRecord: number, i: number) => {
          const record = find(this.valuesMaster, {id: specificRecord});
          if (record) {
            const row = { id: specificRecord, index: i };
            row[this.colSel] = record.valores[this.colSel];
            this.specificRecordSelect.push(row);
          }
        });
      }
    } else {
      if (this.specificRecordSelect && this.specificRecordSelect.length) {
        this.specificRecordSelect.forEach((el, i) => {
          el['index'] = i;
        });
      } else {
        this.specificRecordSelect = [];
      }
    }
    this.sourceData = new LocalDataSource(this.specificRecordSelect);
    this.saveSpecificRecord();
  }

  /**
   * Guarda o edita el registro especifico
   *
   * @param {*} data
   * @memberof CheckListParametersComponent
   */
  sended(data: any) {
    const rowExist = findIndex(this.specificRecordSelect, {id: data.cboRegister});
    if (rowExist === -1 ||
      (
        this.rowData &&
        this.rowData.hasOwnProperty('index') &&
        rowExist === this.rowData['index']
      )
    ) {
      const row = { id: data.cboRegister };
      const record = find(this.valuesMaster, {id: data.cboRegister});
      if (record) {
        row[this.colSel] = record.valores[this.colSel];
      }
      if (this.editForm) {
        row['index'] = this.rowData['index'];
        this.specificRecordSelect[this.rowData['index']] = row;
      } else {
        this.specificRecordSelect.push(row);
      }
      this.sourceData.refresh();
      this.defineAction('close');
      this.loadSpecificRecord(true);
    } else {
      this.toastr.error('El registro ya se encuentra seleccionado', 'Información existente');
    }
  }

  /**
   * Cierra el modal del formulario renderizado de la tabla maestra
   *
   * @param {boolean} [loading=false]
   * @memberof CheckListParametersComponent
   */
  closeModalFormMaster(loading: boolean = false) {
    this.actionRow = 'Agregar';
    this.modificar = false;
    this.registroSeleccionado = null;
    this.modalRef.hide();
    if (loading) {
      this.loadOptions(true);
    }
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof CheckListParametersComponent
   */
  async actionSelectModal(data: AccionModal) {
    switch (data.accion) {
      case 'eliminar':
        this.confirm.new({
          question: '¿Realmente deseas eliminar el registro?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            const idregistro = data.registroSeleccionado['key'];
            this.clpds.deleteInformationDynamicTableMaster(idregistro).subscribe(async response => {
              if (response) {
                this.loadOptions(true);
              }
            });
          }
        });
        break;
      case 'agregar':
        this.actionRow = 'Agregar';
        this.modificar = false;
        this.registroSeleccionado = null;
        this.openModalFormMasterTable();
        break;
      case 'actualizar':
        this.actionRow = 'Modificar';
        this.loadingProcess = true;
        this.modificar = true;
        this.messaggeLoading = 'Cargando el registro...';
        this.registroSeleccionado = await this.clpds.getInformationDynamicTableMaster(
          data.registroSeleccionado['key']
        ).catch(err => this.loadingProcess = false);
        this.openModalFormMasterTable();
        this.loadingProcess = false;
        break;
    }
  }

  /**
   * Abre el modal con el formulario renderizado de la tabla maestra
   *
   * @private
   * @memberof CheckListParametersComponent
   */
  private openModalFormMasterTable() {
    this.modalRef = this.modalService.show(
      this.templateRefactorMasterTable,
        {
          class: 'modal-lg-personalized',
          backdrop: 'static'
        }
    );
  }

  /**
   * Genera la estructura para consultar los valores de la maestra
   * dependiendo de la columna seleccionada para mostrar el requerimiento
   *
   * @private
   * @param {string} idMaster
   * @param {string} column
   * @returns {EstructuraEspecifica}
   * @memberof CheckListParametersComponent
   */
  private generateStructureMasterTable(idMaster: string, column: string): EstructuraEspecifica {
    const structure: EstructuraEspecifica = {
      maestra: idMaster,
      columnas: [],
      dependencia: []
    };
    const cols = column.split('_');
    if (cols.length > 1) {
      let structureCol = '';
      const idMasterCol = cols[0];
      cols.splice(0, 1);
      cols.forEach((col, i) => {
        if (i !== 0) {
          structureCol += '_';
        }
        structureCol += col;
      });
      structure.dependencia.push(this.generateStructureMasterTable(idMasterCol + ' ', structureCol));
    } else {
      structure.columnas.push(cols[0] + ' ');
    }

    return structure;
  }

  /**
   * Elimina el registro especifico seleccionado
   *
   * @private
   * @memberof CheckListParametersComponent
   */
  private deleteRecordSelect() {
    this.specificRecordSelect.splice(this.rowData['index'], 1);
    this.loadSpecificRecord(true);
    this.defineAction('close');
  }

  /**
   * Emite los registros seleccionados
   *
   * @private
   * @memberof CheckListParametersComponent
   */
  private saveSpecificRecord() {
    const recordSpecific: number[] = [];
    if (this.specificRecordSelect && this.specificRecordSelect.length) {
      this.specificRecordSelect.forEach(el => {
        recordSpecific.push(el['id']);
      });
    }
    this.saveRecordSpecific.emit(recordSpecific);
  }

  /**
   * Actualiza las opciones de un campo ya configurado
   *
   * @private
   * @param {*} options
   * @param {string} control
   * @memberof CheckListParametersComponent
   */
  private loadingOptionsControl(options: any, control: string) {
    if (this.controls.length) {
      this.controls.forEach(ctlConfig => {
        if (ctlConfig.controlType === 'container') {
          this.loadingOptionsControl(options, control);
        } else {
          if (ctlConfig.key === control) {
            ctlConfig['data'] = options;
          }
        }
      });
    }
  }

  /**
   * Consulta los registros configurados para la lista de chequeo y los carga en el selector correspondiente
   *
   * @private
   * @param {boolean} [refresh=false]
   * @memberof CheckListParametersComponent
   */
  private loadOptions(refresh: boolean = false) {
    const structure = this.generateStructureMasterTable(String(this.master.id), this.columnSelect);
    this.clpds.getColumnsSpecificMasterTable(structure).then(data => {
      this.valuesMaster = data;
      this.options = [];
      if (this.valuesMaster.length) {
        this.valuesMaster.forEach(value => {
          this.options.push({
            key: value.id,
            value: value.valores[this.columnSelect],
          });
        });
      }
      if (refresh) {
        this.refreshOptionsSelect();
      } else {
        this.Init();
      }
    });
  }

  /**
   * Refresca las opciones del selector
   *
   * @private
   * @memberof CheckListParametersComponent
   */
  private refreshOptionsSelect() {
    if (this.options.length) {
      this.loadingOptionsControl(this.options, 'cboRegister');
    }
    this.gns.set<any>({
      source: 'RefactorDynamicFormComponent',
      destiny: 'ModalSelectComponent-cboRegister',
      action: 'loadingData',
      eventTriggered: 'click',
      data: <any> this.options
    }, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/shared-administration/check-list-parameters/check-list-parameters.component.ts